import { Components, Theme } from '@mui/material';

export const MuiLink: Components<Theme>['MuiLink'] = {
  defaultProps: {
    color: 'primary',
    underline: 'none',
  },
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.secondary.main,
    }),
  },
};
